import { BaseAPI } from './BaseAPI.js'
import { Trunk } from '../types/index.js'

export default class TrunksAPI extends BaseAPI<Trunk> {
  override get resource(): string {
    return '/trunks'
  }
}
